import {
  apiClient,
  getStoredAuth,
  resolveApiErrorMessage,
} from './authApi';

function withAuthHeaders() {
  const { accessToken } = getStoredAuth();

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

function withNoCacheHeaders() {
  return {
    ...withAuthHeaders(),
    'Cache-Control': 'no-cache, no-store, max-age=0',
    Pragma: 'no-cache',
    Expires: '0',
  };
}

export const financeApi = {
  async listPaymentRequests(options = {}) {
    const { bustCache = false } = options;
    const response = await apiClient.get('/payment-requests', {
      headers: withNoCacheHeaders(),
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async createPaymentRequest(payload) {
    const response = await apiClient.post('/payment-requests', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async updatePaymentRequest(paymentRequestId, payload) {
    const response = await apiClient.put(`/payment-requests/${paymentRequestId}`, payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async uploadPaymentRequestAttachment(file) {
    const formData = new FormData();
    formData.append('file', file);

    const { accessToken } = getStoredAuth();
    const response = await apiClient.post('/payment-requests/attachments/upload', formData, {
      headers: {
        Accept: 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    });

    return response.data;
  },

  async listLiquidations(options = {}) {
    const { bustCache = false } = options;
    const response = await apiClient.get('/liquidations', {
      headers: withNoCacheHeaders(),
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async createLiquidation(payload) {
    const response = await apiClient.post('/liquidations', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async uploadLiquidationAttachment(file) {
    const formData = new FormData();
    formData.append('file', file);

    const { accessToken } = getStoredAuth();
    const response = await apiClient.post('/liquidations/attachments/upload', formData, {
      headers: {
        Accept: 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    });

    return response.data;
  },

  async updateLiquidation(liquidationId, payload) {
    const response = await apiClient.put(`/liquidations/${liquidationId}`, payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async listReplenishments(options = {}) {
    const { bustCache = false } = options;
    const response = await apiClient.get('/replenishments', {
      headers: withNoCacheHeaders(),
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async createReplenishment(payload) {
    const response = await apiClient.post('/replenishments', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async updateReplenishment(replenishmentId, payload) {
    const response = await apiClient.put(`/replenishments/${replenishmentId}`, payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async uploadReplenishmentAttachment(file) {
    const formData = new FormData();
    formData.append('file', file);

    const { accessToken } = getStoredAuth();
    const response = await apiClient.post('/replenishments/attachments/upload', formData, {
      headers: {
        Accept: 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    });

    return response.data;
  },
};

export function resolveFinanceApiError(error) {
  return resolveApiErrorMessage(error, 'Failed to process finance request.');
}
